import { useCallback, useEffect, useState } from 'react';

/**
 * Мини-роутер на History API.
 *
 * Экранов пять — главная, создание комнаты, открытые комнаты, профиль и сама
 * комната.
 * Полноценная библиотека маршрутизации здесь весила бы больше, чем весь
 * остальной код страницы.
 */

export type Route =
  | { name: 'home' }
  | { name: 'new' }
  | { name: 'rooms' }
  | { name: 'profile' }
  | { name: 'room'; code: string };

export function parseRoute(pathname: string): Route {
  const match = /^\/r\/([a-z0-9]+)\/?$/i.exec(pathname);
  if (match?.[1]) return { name: 'room', code: match[1].toLowerCase() };

  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/new') return { name: 'new' };
  if (path === '/rooms') return { name: 'rooms' };
  if (path === '/profile') return { name: 'profile' };
  return { name: 'home' };
}

export function navigate(path: string): void {
  window.history.pushState({}, '', path);
  // pushState не уведомляет слушателей сам — делаем это вручную.
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function useRoute(): { route: Route; go: (path: string) => void } {
  const [route, setRoute] = useState<Route>(() => parseRoute(window.location.pathname));

  useEffect(() => {
    const handlePopState = (): void => setRoute(parseRoute(window.location.pathname));
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const go = useCallback((path: string) => {
    navigate(path);
    // Переход на новый экран начинается сверху, а не с середины прошлого.
    window.scrollTo({ top: 0 });
  }, []);

  return { route, go };
}
